var _excluded = ["onClick", "style", "closed", "color", "isOpenLabel", "isClosedLabel", "labelStyle", "ariaLabel"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { IconUp, IconDown } from "../Icon";
import { colors } from "../../styleguide";
import buttonStyles from "./ShowMoreButton.styles";
export var ShowMoreButton = function ShowMoreButton(_ref) {
  var onClick = _ref.onClick,
      style = _ref.style,
      _ref$closed = _ref.closed,
      closed = _ref$closed === void 0 ? false : _ref$closed,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors.blue600 : _ref$color,
      _ref$isOpenLabel = _ref.isOpenLabel,
      isOpenLabel = _ref$isOpenLabel === void 0 ? 'Dölj' : _ref$isOpenLabel,
      _ref$isClosedLabel = _ref.isClosedLabel,
      isClosedLabel = _ref$isClosedLabel === void 0 ? 'Visa mer' : _ref$isClosedLabel,
      labelStyle = _ref.labelStyle,
      ariaLabel = _ref.ariaLabel,
      other = _objectWithoutProperties(_ref, _excluded);

  var IconComponent = closed ? IconDown : IconUp;
  return /*#__PURE__*/React.createElement("button", _extends({
    style: _objectSpread({
      cursor: 'pointer',
      width: 'auto',
      backgroundColor: 'transparent'
    }, style),
    onClick: onClick,
    "aria-label": ariaLabel
  }, other), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'nowrap',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: _objectSpread(_objectSpread({}, buttonStyles.label), {}, {
      color: color
    }, labelStyle)
  }, closed ? isClosedLabel : isOpenLabel), /*#__PURE__*/React.createElement(IconComponent, {
    style: {
      marginLeft: 8
    },
    width: 16,
    height: 16,
    color: color
  })));
};
ShowMoreButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Optional callback to run on the click event
   */
  onClick: PropTypes.func,
  style: PropTypes.object,

  /**
   * Set to change the color of the label and arrow
   */
  color: PropTypes.string,

  /**
   * Set to change label or style when button is active
   */
  closed: PropTypes.bool,

  /**
   * Add a aria label to help screen readers define the current element
   * where a text label is not visible.
   */
  ariaLabel: PropTypes.string,
  isOpenLabel: PropTypes.string,
  isClosedLabel: PropTypes.string,
  labelStyle: PropTypes.object
} : {};
export default ShowMoreButton;
//# sourceMappingURL=ShowMoreButton.js.map